import { Component, OnInit, TemplateRef, ChangeDetectorRef, AfterViewInit} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../../services/admin.service";
import { apiUrl } from "../../../global/global"; 
import { HttpClient, HttpParams } from "@angular/common/http";
import { DatePipe } from "@angular/common" 
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import * as CONSTANT from "../../../services/constants"
import * as Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsSolidGauge from "highcharts/modules/solid-gauge"
import { ExcelService } from "src/app/services/excel.service";

HighchartsMore(Highcharts);
HighchartsSolidGauge(Highcharts);

@Component({
  selector: "app-job-report",
  templateUrl: "./job-report.component.html",
  styleUrls: ["./job-report.component.css"]
})
export class JobReportComponent implements OnInit, AfterViewInit {
  Highcharts: typeof Highcharts = Highcharts;
  public userDatas: any;
  allData:any;
  tableData:any=[];
  top6jobs : any = []
  
  color= ["#AF6F50","#8FAD51","#AF7B48","#4F4F7E","#A75050","#A28D55","#8B8B8B","#517595","#935A91","#D8905E","#4D7DAD","#51ACAC",]

  currentPage=1;
  pagination = {limit: CONSTANT.LIMIT, maxSize: CONSTANT.MAX_SIZE, skip: 0, totalItems: ""}
  maxDate: Date;
  today: Date;
  invalidDateFilter = false;
  noDataFound = false;
  fromDate: any;
  toDate: any;
  totalCount: any;
  show = 0;
  filterForm: FormGroup;
  modalRef?: BsModalRef;
  config = {
    backdrop: true,
    ignoreBackdropClick: false
  };
  showError = false;

  constructor( private excelService:ExcelService,public route: ActivatedRoute,  private router: Router, private api: AdminService, public datePipe: DatePipe, private formBuilder: FormBuilder,private modalService: BsModalService, private ref:ChangeDetectorRef) {  
    this.filterForm = this.formBuilder.group({
      startDate: new FormControl("", [Validators.required]),
      endDate: new FormControl("", [Validators.required]),
    });
    this.today = new Date();
    this.maxDate = new Date(this.today.getDate() + 3);
  }
  ngAfterViewInit(): void {
    // this.createChartColumn();
    // this.ref.detectChanges()
  }
  ngOnInit(): void {
    this.getDashboard(); 
    this.getJobPerformanceList();  
  }
   
  getDashboard(){
    let params = new HttpParams();
    if (this.fromDate) {
      params = params.append("startDate", this.fromDate);
    }
    if (this.toDate) {
      params = params.append("endDate", this.toDate);
    } 
    this.api.getData(apiUrl._jobPerformance,params)
    .subscribe(async (res) => { 
      this.top6jobs=[]
      this.allData = res.data;   
      this.noDataFound = true; 
      if(this.allData?.mobileClicks > 0 || this.allData?.desktopClicks > 0){
        this.noDataFound = false
      }
      for (let data of this.allData.top6jobs) {
        if(data.count > 0){
          this.noDataFound = false
        }
        this.top6jobs.push({
          name: data.title,
          y: data.count,
        });
      }
      this.createChartColumn();
      this.ref.detectChanges()
    })
  } 
  getJobPerformanceList(){
    let params = new HttpParams(); 
    params = params.append("skip", this.pagination.skip.toString());
    params = params.append("limit", this.pagination.limit.toString());
    if (this.fromDate) {
      params = params.append("startDate", this.fromDate);
    }
    if (this.toDate) {
      params = params.append("endDate", this.toDate);
    } 
    this.api.getData(apiUrl._jobPerformanceTable,params)
    .subscribe(async (res) => { 
      this.totalCount = res.data; 
      this.tableData = res.data.data;  
      this.pagination.totalItems = res.data.jobsCount; 
    })
  } 
     
  pageChanged(event: any): void {
    if (event == this.currentPage) return;
    this.currentPage = event;
    this.pagination.skip = (event - 1) * this.pagination.limit;
    window.scroll(0, 0);
    this.getJobPerformanceList();
  }
  // hightchart 
 
  private createChartColumn(): void {  
    const chart = Highcharts.chart("bar-Horizontal" as any, {
      
    color: ["#4D7DAD","#51ACAC","#AF6F50","#8FAD51","#4F4F7E","#A28D55"],
    chart: {
      type: "bar"
    },
    title: {
      text: ""
    },
    xAxis: {
      type: "category",
    },
    yAxis: {
      min: 0,
      title: "",
      labels: {
        overflow: "justify"
      }
    }, 
    plotOptions: {
      bar: {
        colorByPoint: true,
        dataLabels: {
          enabled: true
        }
      }
    },
    legend: {
      enable: false
    },
    credits: {
      enabled: false
    },
    series: [
      {
        name: "Top 6 jobs by impressions",
        data: this.top6jobs}
    ]
  
    } as any); 
    const chart1 = Highcharts.chart("pie" as any, {  
      chart : {
         plotBorderWidth: null,
         plotBackgroundColor: null,
         plotShadow: false,
         type: 'pie'
      },
      title : {
         text: ''   
      },
      legend: {
        floating: true,
        align: 'left',
        layout: 'vertical',
        verticalAlign: 'top',
        width: 300,
        x: 150,
        y: -40
    },
      tooltip : {
         pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      plotOptions : {
         pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
               enabled: false,
               format: '<b>{point.name}</b>: {point.percentage:.1f} %',
               style: {
                  color: (Highcharts.theme && Highcharts.theme)||
                  'black'
               }
            },
            showInLegend: true
         }
      },
      series : [{
         type: 'pie',
         name: 'Browser share',
         colorByPoint: true,
         colors: ["#4D7DAD", "#8FAD51"],
         data: [  
           ['Desktop Clicks',    this.allData?.desktopClicks],  
           ['Mobile Clicks',    this.allData?.mobileClicks], 
         ]
      }]
    } as any); 
  }

  openModal(template: TemplateRef<any>) {
    this.modalService.show(template);
  }
  close() {
    this.modalRef?.hide();
  }
  
  applyFilter(modal: any) {
    this.fromDate = this.datePipe.transform(
      this.filterForm.value.startDate,
      "yyyy-MM-dd"
    );
    this.toDate = this.datePipe.transform(
      this.filterForm.value.endDate,
      "yyyy-MM-dd"
    );
    if (this.filterForm.valid) {
      if (this.fromDate && this.toDate) {
        if (this.fromDate > this.toDate) {
          this.invalidDateFilter = true;
          setTimeout(() => {
            this.invalidDateFilter = false;
          }, 4000);
          return;
        }
      }
      this.getDashboard();
      this.getJobPerformanceList();
      this.show = 1;
      this.modalService.hide();
    } else {
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 3000);
      return;
    }
  }

  clearFilter(modal: any) {
    this.filterForm.reset();
    this.fromDate = "";
    this.toDate = "";
    this.show = 0;
    this.modalRef?.hide();
    this.modalService.hide();
    this.getDashboard();
    this.getJobPerformanceList();
  }

  // download Csv file
  downloadCsv(){
    let excelData: any;  
    let dataToSend:any = []
    let allData:any = [] 
    let params = new HttpParams(); 
    params = params.append("skip", this.currentPage);
    params = params.append("limit", this.pagination.limit.toString());
    if (this.fromDate) {
      params = params.append("startDate", this.fromDate);
    }
    if (this.toDate) {
      params = params.append("endDate", this.toDate);
    } 
    this.api.getData(apiUrl._jobPerformanceTable,params)
    .subscribe(async (res) => {
      let allData = res.data.data;
      allData.map(val=>{
        const data = {
          "Status": (val?.isBlocked == 0 && val?.isConfirm == 1 ? "Open" : val?.isBlocked == 1 && val?.isConfirm == 1 ? "Closed" : val?.isConfirm == 0 ? "Draft" : ""),
          "Job title": val?.jobTitle,
          "Location": val?.workPlaceLocation == "Remote" ? "Remote" : val?.location,
          "Job ID": val?.id,
          "Last updated date":  this.datePipe.transform(val?.updatedAt,"d/M/YYYY"),
          "Impressions": val?.impressions || "0",
          "Clicks": val?.total || "0",
          "Apply starts": val?.applyStart || "0",
          "CTR": val?.ctr || "0",
          "Apply start rate": val?.applyStartRate || "0",
          "Apply completion rate": val?.applyComplition || "0",
        }
        dataToSend.push(data)
      })
      excelData = dataToSend;
      this.excelService.exportAsExcelFile(excelData, "Job performance report");
    });
  }
}

